
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { APP_BASE_HREF } from '@angular/common';


const baseHref = (environment.firebaseAppJunction || '/scio-nav-dev/**').replace('**', '');

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    { provide: APP_BASE_HREF, useValue: baseHref }
  ]
}).catch(err => console.error(err));
